<template>
    <div>
        <loading-custom :loading="loading" />
        <div class="card mb-0">
            <div class="tw-grid md:tw-grid-cols-3 tw-gap-4">
                <div class="tw-col-span-1 tw-flex tw-justify-between">
                    <div class="md:px-4 py-4 sm:px-0">
                        <h3 class="tw-text-lg tw-font-medium tw-text-gray-900">
                            Menu Style
                        </h3>
                        <p class="m-0 tw-text-sm tw-text-gray-600">
                            เลือกรูปแบบหน้าเมนู
                        </p>
                    </div>
                </div>
                <div class="tw-col-span-2 tw-flex">
                    <div class="md:px-4 py-4 sm:px-0 tw-w-full">
                        <div class="tw-grid tw-flex tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-2 tw-justify-items-center md:tw-justify-items-start">
                            <div
                                class="btn btn-default p-2 tw-w-10/12 md:tw-w-full"
                                :class="{ active: this.menuStyle == 'classic' }"
                                @click="changeMenuStyle('classic')"
                            >
                                <img
                                    class="tw-w-full"
                                    src="/images/menu_style/Products_Classic.png"
                                />
                                <div class="tw-self-center mt-1 md:mt-2" :class="{'tw-font-bold' : this.menuStyle == 'classic'}">
                                    แบบคลาสสิค
                                </div>
                            </div>
                            <div
                                class="btn btn-default p-2 tw-w-10/12 md:tw-w-full"
                                :class="{ active: this.menuStyle == 'modern' }"
                                @click="changeMenuStyle('modern')"
                            >
                                <img
                                    class="tw-w-full"
                                    src="/images/menu_style/Product_Modern.png"
                                />
                                <div class="tw-self-center mt-2" :class="{'tw-font-bold' : this.menuStyle == 'modern'}">
                                    แบบโมเดิร์น
                                </div>
                            </div>
                            <div
                                class="btn btn-default p-2 tw-w-10/12 md:tw-w-full"
                                :class="{ active: this.menuStyle == 'grid' }"
                                @click="changeMenuStyle('grid')"
                            >
                                <img
                                    class="tw-w-full"
                                    src="/images/menu_style/Product_Grid.png"
                                />
                                <div class="tw-self-center mt-2" :class="{'tw-font-bold' : this.menuStyle == 'grid'}">
                                    แบบกริด
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["shop", "salePage"],
    data() {
        return {
            menuStyle: "",
            loading: false
        };
    },
    methods: {
        onUpdate() {
            this.getMenuStyle();
        },
        getMenuStyle() {
            this.loading = true;
            axios
                .get(
                    `/backend/s/${this.shop}/salepages/${this.salePage.id}/menu-style`
                )
                .then(response => {
                    this.menuStyle = response.data.data;
                    this.loading = false;
                });
        },
        changeMenuStyle(style) {
            this.loading = true;
            axios
                .post(
                    `/backend/s/${this.shop}/salepages/${this.salePage.id}/menu-style`,
                    {
                        style
                    }
                )
                .then(response => {
                    this.onUpdate();
                })
                .catch(err => {
                    this.$swal({
                        icon: "error",
                        title: "เกิดข้อผิดพลาด",
                        text: "ไม่สามารถเปลี่ยนรูปแบบหน้าเมนูได้",
                        showConfirmButton: true
                    });
                    this.loading = false;
                });

            this.loading = false;
        }
    },
    mounted() {
        this.getMenuStyle();
    }
};
</script>
<style scoped>
.active {
    background: #fdd736;
    border: 3px solid #fdd736;
    font-weight: bold;
}
</style>
